import React from 'react';
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import {attachment, ClearIcon} from "../../../assets/images/images";
import TextField from "@material-ui/core/TextField";
import './style.scss'
import Button from '@material-ui/core/Button';


function Index(props) {
  // fileSize=2097152 == 2mb
  const {
    item,
    item: {id, label, value, error, labelWidth, maxSize = 2097152, noOfFiles = 0, multiple = false},
    onChangeInput
  } = props;
  // console.log(item.accept)
  return (
    <FormControl
      variant="outlined"
      fullWidth
      // margin='dense'
      error={error ? error : false}
    >
      <div style={{position: 'relative'}} className='display-flex align-items-center'>
        <OutlinedInput
          id={id || label}
          fullWidth
          placeholder={label+ ' (max size 2MB)'}
          value={value}
          error={error}
          helperText={item?.error}
          // onChange={(e) =>
          //   onChangeInput(e.target.files[0], id)
          // }
          labelWidth={labelWidth}
          // style={{zIndex: -500}}
          endAdornment={<InputAdornment position={'end'}>
            <IconButton edge={'start'} className='pr-0'>
              <img src={attachment} style={{width: 20}} alt=''/>
              {/*<att />*/}
            </IconButton>
          </InputAdornment>}

        />

        <TextField
          className='file'
          // fullWidth=}
          id={id}
          type="file"
          // value={item.value}
          // multiple={true}
          error={error}
          helperText={item?.error}
          inputProps={{accept: item?.accept, multiple: multiple}}
          // inputProps={{accept: 'image/*', multiple: multiple}}
          onChange={e => {
            var ac = item?.accept;
            if (ac) {
              ac = ac.split('/')[0]
              if (ac) {

              }
            }
            const checkFileType = (files) => {
              let newFileArray = []
              for (let i = 0; i < files.length; i++) {
                let fileType = files[i].type
                if (fileType.search(ac) >= 0) {
                  newFileArray.push(files[i])
                }
              }
              return newFileArray
            }
            if (multiple) {
              let files = ''
              let filesList = []
              let keys = Object.keys(e.target.files).length

              if ((noOfFiles) && (keys > noOfFiles)) {
                keys = noOfFiles;
              }
              for (let i = 0; i < keys; i++) {

                files = e.target.files[i]
                if ((maxSize <= files.size)) {
                  continue;
                }
                filesList.push(files)
              }
              let cleanFiles = checkFileType(filesList);
              if (cleanFiles.length > 0) {
                onChangeInput(filesList, id || label)
              }
            } else {
              if ((e.target.files[0].size <= maxSize)) {
                let cleanFiles = checkFileType([e.target.files[0]]);
                if (cleanFiles.length > 0) {
                  onChangeInput(cleanFiles[0], id || label)
                }
              }
            }

            // const type = e.target?.files[0]?.type || ''
            // if ((item.fileType === 'excel') && (type === '.csv' ||
            //   type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            //   type === 'application/vnd.ms-excel'
            // )) {

          }}
        />
        {item?.value && <ClearIcon
          style={{color: 'red', padding: 5}}
          className='cursor-pointer'
          onClick={e => {
            console.log('remvoe')
            onChangeInput("", id || label)
          }}/>
        }
        {
          item?.endAdornment && value &&
          <Button type="submit" variant="contained" color="primary" onClick={item.endAdornment.onClick}>
            {item.endAdornment?.text && item.endAdornment?.text || item.endAdornment?.icon}
          </Button>
        }
      </div>
      {error && <p className='error-class'>{error}</p>}
    </FormControl>
  );
}

export default Index;
